import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateDealerSageMapping } from '../services/dealerSageMappings';
import type { DealerSageMappingChange } from '../types/dealerSageMappings.types';
import { dealerKeys } from './useDealersQuery';

export function useDealerSageMappingMutation(dealerId: string) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (change: DealerSageMappingChange) => updateDealerSageMapping(dealerId, change),
        onMutate: () => ({ mutatedDealerId: dealerId }),
        onSuccess: (_data, _change, context) =>
            queryClient.invalidateQueries({ queryKey: dealerKeys.sageMappings(context?.mutatedDealerId ?? dealerId) }),
    });
}
